module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Assess and analyse reserves on your entire book of claims. Perform predictive analysis to help with IBNR\n        assessments. Changes in IBNR requirements following discount rate changes can be performed in seconds —\n        even for 1000s of claims.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Please select claims and two discount rates to compare Heads of Loss\n    ")]), _vm._v(" "), (_vm.individualClaim) ? _c('div', [_c('individual-search')], 1) : _c('div', [_c('book-of-business-search')], 1), _vm._v(" "), _c('discount-rates'), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    attrs: {
      "disabled": _vm.disableCompare
    },
    on: {
      "click": function($event) {
        return _vm.compare()
      }
    }
  }, [_vm._v("Compare")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.loading && _vm.results.count === undefined) ? _c('div', {
    staticClass: "a-loader--results"
  }) : _vm._e(), _vm._v(" "), (_vm.results.count > 0) ? _c('div', {
    staticStyle: {
      "margin": "20px 0 40px"
    }
  }, [_vm._v("\n        Discount Rate Comparison based on " + _vm._s(_vm.results.count) + " matching claims.\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e3d8099!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/PageForm.vue
// module id = 1571
// module chunks = 0